import objectFitImages from 'object-fit-images';
import './status-messages.js';
import './data-toggle.js';
import './main-navigation.js';

objectFitImages();
